import React, { Component } from 'react'
import { compose } from 'redux'
import withTabbedForm from 'components/Shared/withTabbedForm'
import withOnboardingSection from 'components/Onboarding/withOnboardingSection'
import PersonalInformationForm from 'components/Onboarding/PersonalInformation/PersonalInformationForm'
import IdentityVerificationForm from 'components/Onboarding/IdentityVerification/IdentityVerificationForm'
import EmploymentDetailsForm from 'components/Onboarding/EmploymentDetails/EmploymentDetailsForm'
import {
  accountHolderFormsList,
  PERSONAL_INFORMATION,
  IDENTITY_VERIFICATION,
  EMPLOYMENT_DETAILS,
}  from 'utils/accountHolderFormsList'
import PropTypes from 'prop-types'
import {
  mapPersonalInformationValues,
  mapIdentityVerificationValues,
  mapEmploymentDetailsValues,
} from 'utils/formDataMapping'
import { 
  accountToContactAdapter,
  contactToAccountAdapter 
} from 'utils/contactUtils'

const TabbedPersonalInformationForm = compose(
  withOnboardingSection,
  withTabbedForm,
)(PersonalInformationForm)

const TabbedIdentityVerificationForm = compose(
  withOnboardingSection,
  withTabbedForm,
)(IdentityVerificationForm)

const TabbedEmploymentDetailsForm = compose(
  withOnboardingSection,
  withTabbedForm,
)(EmploymentDetailsForm)

class FullAccountInformationFormGroup extends Component {
  constructor (props) {
    super(props)
    const { getDescription } = this.props
    this.state = {
      currentTab: accountHolderFormsList[0],
      description: getDescription(PERSONAL_INFORMATION),
      isFormValid: true,
    }
    this.goToNextSection = this.goToNextSection.bind(this)
    this.handleChangeSelectedTab = this.handleChangeSelectedTab.bind(this)
    this.mapValues = this.mapValues.bind(this)
    this.handleFormValidityChange = this.handleFormValidityChange.bind(this)
  }

  handleFormValidityChange (isFormValid) {
    this.setState({ isFormValid })
  }

  handleChangeSelectedTab (tabClicked) {
    const { getDescription } = this.props
    const description = getDescription(accountHolderFormsList[tabClicked])
    this.setState({
      currentTab: accountHolderFormsList[tabClicked],
      description
    })
  }

  mapValues (inputs) {
    const { currentTab } = this.state
    const { contact } = this.props
    let mappedValues
    switch (currentTab) {
      case PERSONAL_INFORMATION:
        mappedValues = mapPersonalInformationValues(inputs)
        break
      case IDENTITY_VERIFICATION:
        mappedValues = mapIdentityVerificationValues(inputs)
        break
      case EMPLOYMENT_DETAILS:
        mappedValues =  mapEmploymentDetailsValues(inputs)
        break
      default:
        break
    }

    return contact ? accountToContactAdapter(mappedValues) : mappedValues
  }

  getForm () {
    const {
      currentTab,
    } = this.state

    let FormComponent
    let subSection

    switch (currentTab) {
      case PERSONAL_INFORMATION:
        FormComponent = TabbedPersonalInformationForm
        subSection = 'PersonalInformation'
        break
      case IDENTITY_VERIFICATION:
        FormComponent = TabbedIdentityVerificationForm
        subSection = 'IdentityVerification'
        break
      case EMPLOYMENT_DETAILS:
        FormComponent = TabbedEmploymentDetailsForm
        subSection = 'EmploymentDetails'
        break
      default:
        break
    }
    return {
      FormComponent,
      subSection,
    }
  }

  goToNextSection () {
    const {
      currentTab,
    } = this.state
    const {
      getDescription,
      handleFinalTab
    } = this.props

    if (currentTab === EMPLOYMENT_DETAILS) {
      handleFinalTab()
    } else {
      this.setState((prevState) => {
        const currentTabIndex =  accountHolderFormsList.indexOf(prevState.currentTab)
        const nextTab = accountHolderFormsList[currentTabIndex + 1]

        return  {
          currentTab : nextTab,
          description: getDescription(nextTab)
        }
      })
    }
  }


  render () {
    const { FormComponent, subSection } = this.getForm()
    const { 
      account, 
      contact,
      formConfiguration,
      generateUpdateAccountHandler, 
    } = this.props
    const { currentTab, description, isFormValid } = this.state

    const formProps = formConfiguration[subSection]

    return (
      <FormComponent
        {...this.props}
        {...formProps}
        data={contact ? contactToAccountAdapter(contact) : account}
        description={[description]}
        currentSelectedTab={accountHolderFormsList.indexOf(currentTab)}
        goNextSection={this.goToNextSection}
        mapValues={this.mapValues}
        tabList={accountHolderFormsList}
        updateAccount={generateUpdateAccountHandler(subSection)}
        isFormValid={isFormValid}
        onChangeSelectedTab={this.handleChangeSelectedTab}
        onFormValidityChange={this.handleFormValidityChange} />
    )
  }

}

FullAccountInformationFormGroup.propTypes = {
  account: PropTypes.object,
  contact: PropTypes.object,
  formConfiguration: PropTypes.object,
  generateUpdateAccountHandler: PropTypes.func,
  getDescription: PropTypes.func.isRequired,
  handleFinalTab: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
}

FullAccountInformationFormGroup.defaultProps = {
  account: {},
  contact: null,
  formConfiguration: {
    PersonalInformation: {},
    IdentityVerification: {},
    EmploymentDetails: {}
  },
  generateUpdateAccountHandler: () => {},
  isMobile: false
}

export default FullAccountInformationFormGroup



// WEBPACK FOOTER //
// ./src/components/Onboarding/FullAccountInformationFormGroup/index.js